module.exports = __webpack_public_path__ + "media/images/landing/crime/product-5-4810ccbff791f255862a3890f9aed599.png";